module.exports = __webpack_public_path__ + "static/coming-soon-fb58419d3d18ebe88d9277d1ec724301.png";